__turbopack_context__.v({
  "container": "HeaderLinks-module-scss-module__thhMXW__container",
  "item": "HeaderLinks-module-scss-module__thhMXW__item",
});
